import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';
import useAxios from '../../../../hooks/useAxios';
import useNotification from '../../../../hooks/useNotification';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { createLine, updateLine } from '../../../../api/shuttleSetting.api';
import Loader from '../../../Loader';
import ErrorResponse from '../../../ErrorResponse';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  doGetLines: () => void;
  line: any;
  setLine: (line: any) => void;
}

const EditLineModal: FC<IProps> = ({
  visible,
  setVisible,
  doGetLines,
  line,
  setLine,
}) => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();
  const [lineName, setLineName] = useState('');
  const [isCreate, setIsCreate] = useState(true);

  useEffect(() => {
    if (line) {
      setLineName(line.lineName);
      setIsCreate(false);
    }
  }, [line]);

  useEffect(() => {
    if (res && !isLoading) {
      doGetLines();
      onCancel();
      successNotification(t('common.message.save1'));
      setVisible(false);
    }
  }, [res, isLoading]);

  const onSubmit = () => {
    if (!lineName) {
      return infoNotification(t('campus.shuttle.message9'));
    }

    if (isCreate) {
      execute(createLine(currentCampus, { lineName }));
    } else {
      execute(
        updateLine(currentCampus, {
          lineCode: line.lineCode,
          lineName,
        }),
      );
    }
  };

  const onCancel = () => {
    setLine(undefined);
    setLineName('');
    setVisible(false);
  }

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={isCreate ? t('campus.shuttle.title2') : t('campus.shuttle.title3')}
        visible={visible}
        onCancel={onCancel}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton key="submit" className='btn-basic pink' onClick={onSubmit}>
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={onCancel}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div>
          <input
            type="text"
            className="form-control"
            placeholder={t("campus.shuttle.placeholder3")}
            value={lineName}
            onChange={(e) => setLineName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') onSubmit();
            }}
          />
        </div>
      </Modal>
    </>
  );
};

export default EditLineModal;
